<mat-form-field class="question-datum-field u-full-width">
  <input matInput [matDatepicker]="picker" [placeholder]="label" disabled="true" [value]="datum" (dateInput)="setDatum($event)">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker disabled="false"></mat-datepicker>
</mat-form-field>